// extracted by css-extract-rspack-plugin
export default {"wrapper":"Separator_wrapper__rOnu6","separator":"Separator_separator__FrGtM"};